import angular from 'angular';

class CommonHttp {
    constructor($http, $q, defaultConfig, httpCache) {
        this.$http = $http;
        this.$q = $q;
        this.defaultRequestConfig = defaultConfig;
        this.httpCache = httpCache;
    }

    request(request) {
        var self = this;
        var cancel = self.$q.defer();

        request = angular.extend(angular.copy(self.defaultRequestConfig), request || {});

        request.timeout = cancel.promise;
        request.cancel = cancel;
        var promise = self.$http(request);

        promise.cancel = cancel;

        // .then method returning new object, so it not have cancel property
        const injectCancelInThenPromise = (localPromise) => {
            const originalLocalPromiseThen = localPromise.then;

            localPromise.then = (onFulfilled, onRejected, progressBack) => {
                let promiseResult = originalLocalPromiseThen.call(localPromise, onFulfilled, onRejected, progressBack);

                promiseResult.cancel = localPromise.cancel;

                return injectCancelInThenPromise(promiseResult);
            };

            return localPromise;
        };
        injectCancelInThenPromise(promise);

        return promise.then(function (response) {
            return response.data || null;
        });
    }

    get(url, config) {
        return this.request(this.createRequest('GET', url, config));
    }

    delete(url, config) {
        return this.request(this.createRequest('DELETE', url, config));
    }

    post(url, data, config) {
        return this.request(this.createRequest('POST', url, config, data));
    }

    put(url, data, config) {
        return this.request(this.createRequest('PUT', url, config, data));
    }

    abortAllPendingRequests() {
        var self = this;

        if (self.$http.pendingRequests) {
            for (var i in self.$http.pendingRequests) {
                if (self.$http.pendingRequests[i].cancel) {
                    self.$http.pendingRequests[i].cancel.resolve('cancelled');
                }
            }
        }
    }

    createRequest(method, url, config, data) {
        var request = config || {};

        request.method = method;
        request.url = url;
        if (data) {
            request.data = data;
        }

        if (
            request.cache === true
            && angular.isDefined(this.httpCache)
        ) {
            request.cache = this.httpCache;
        }

        return request;
    }
}

export default CommonHttp;
